<template>
    <div>
        <v-row justify="center">
            <v-dialog   content-class="custom-dialog" 
                        style="[window.width <= 655 ? '{margin:3 !important;}' : 'margin:3 !important;'" 
                        v-model="record_keeping_credit_dialog" max-width="900px">
                <template v-slot:activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on">Override Credits</button>
                    <!--
                    <v-btn class="pa-0 pr-2" v-bind="attrs" v-on="on">
                        Override Credits
                    </v-btn>
                    -->
                </template>
                <v-card>
                    <v-toolbar color="primary custom-toolbar" dark>
                        <span>{{viewModel.packet.rk_name}} Revenue Share</span>
                    </v-toolbar>
                    <div v-if="window.width <= 650" class="custom-card-content">
                        <div class="sections">
                            <v-toolbar color="primary custom-toolbar content-title" dark>Pricing</v-toolbar>
                            <div class="section-content-wrapper">
                                <div class="section-header-mobile">
                                    <div><span></span></div>
                                    <div><span>Year 1</span></div>
                                    <div><span>Year 2</span></div>
                                    <div><span>Year 3</span></div>
                                    <div v-if="duration>=4"><span>Year 4</span></div>
                                    <div v-if="duration>=5"><span>Year 5</span></div>
                                </div>
                                <div class="section-data-row-mobile">
                                    <div><span>Total Fees</span></div>
                                    <div class="align-right"><span>${{ dollar(getTotalFees().total_fee_year_one) }}</span></div>
                                    <div class="align-right"><span>${{ dollar(getTotalFees().total_fee_year_two) }}</span></div>
                                    <div class="align-right"><span>${{ dollar(getTotalFees().total_fee_year_three) }}</span></div>
                                    <div v-if="duration>=4" class="align-right"><span>${{ dollar(getTotalFees().total_fee_year_four) }}</span></div>
                                    <div v-if="duration>=5" class="align-right"><span>${{ dollar(getTotalFees().total_fee_year_five) }}</span></div>
                                </div>
                            </div>
                        </div>
                        <div class="sections">
                            <v-toolbar color="primary custom-toolbar content-title" dark>Revenue Sharing Estimate</v-toolbar>
                            <div class="section-content-wrapper">
                                <div class="section-header-mobile">
                                    <div><span></span></div>
                                    <div><span>Installation Credits</span></div>
                                    <div><span>Ongoing Credits</span></div>
                                    <div><span>Total Credits</span></div>
                                    <div v-if="applyRevShare"><span>Revenue Share Carryover</span></div>
                                    <div><span>Billed Fee</span></div>
                                </div>
                                <div class="section-data-row-mobile">
                                    <div><span>Year 1</span></div>
                                    <div><input type="text" :disabled="isPDFGenerated" v-model="json.installation_credit_year_one"></div>
                                    <div><input type="text" :disabled="isPDFGenerated" v-model="json.ongoing_credit_year_one"></div>
                                    <div class="align-right"><span>${{ dollar(json.total_credits_year_one) }}</span></div>
                                    <div class="align-right" v-if="applyRevShare"><span>${{ dollar(json.revenue_share_carryover_year_one) }}</span></div>
                                    <div class="align-right"><span>${{ dollar(json.net_fee_year_one) }}</span></div>
                                </div>
                                <div class="section-data-row-mobile">
                                    <div><span>Year 2</span></div>
                                    <div><input type="text" :disabled="isPDFGenerated" v-model="json.installation_credit_year_two"></div>
                                    <div><input type="text" :disabled="isPDFGenerated" v-model="json.ongoing_credit_year_two"></div>
                                    <div class="align-right"><span>${{ dollar(json.total_credits_year_two) }}</span></div>
                                    <div class="align-right" v-if="applyRevShare"><span>${{ dollar(json.revenue_share_carryover_year_two) }}</span></div>
                                    <div class="align-right"><span>${{ dollar(json.net_fee_year_two) }}</span></div>
                                </div>
                                <div class="section-data-row-mobile">
                                    <div><span>Year 3</span></div>
                                    <div><input type="text" :disabled="isPDFGenerated" v-model="json.installation_credit_year_three"></div>
                                    <div><input type="text" :disabled="isPDFGenerated" v-model="json.ongoing_credit_year_three"></div>
                                    <div class="align-right"><span>${{ dollar(json.total_credits_year_three) }}</span></div>
                                    <div class="align-right" v-if="applyRevShare"><span>${{ dollar(json.revenue_share_carryover_year_three) }}</span></div>
                                    <div class="align-right"><span>${{ dollar(json.net_fee_year_three) }}</span></div>
                                </div>
                                <div class="section-data-row-mobile"  v-if="duration>=4">
                                    <div><span>Year 4</span></div>
                                    <div><input type="text" :disabled="isPDFGenerated" v-model="json.installation_credit_year_four"></div>
                                    <div><input type="text" :disabled="isPDFGenerated" v-model="json.ongoing_credit_year_four"></div>
                                    <div class="align-right"><span>${{ dollar(json.total_credits_year_four) }}</span></div>
                                    <div class="align-right" v-if="applyRevShare"><span>${{ dollar(json.revenue_share_carryover_year_four) }}</span></div>
                                    <div class="align-right"><span>${{ dollar(json.net_fee_year_four) }}</span></div>
                                </div>
                                <div class="section-data-row-mobile" v-if="duration>=5">
                                    <div><span>Year 5</span></div>
                                    <div><input type="text" :disabled="isPDFGenerated" v-model="json.installation_credit_year_five"></div>
                                    <div><input type="text" :disabled="isPDFGenerated" v-model="json.ongoing_credit_year_five"></div>
                                    <div class="align-right"><span>${{ dollar(json.total_credits_year_five) }}</span></div>
                                    <div class="align-right" v-if="applyRevShare"><span>${{ dollar(json.revenue_share_carryover_year_five) }}</span></div>
                                    <div class="align-right"><span>${{ dollar(json.net_fee_year_five) }}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="window.width >= 651" class="custom-card-content">
                        <div class="sections">
                            <v-toolbar color="primary custom-toolbar content-title" dark>Pricing Totals</v-toolbar>
                            <div class="section-header">
                                <div><span>Year 0</span></div>
                                <div><span>Year 1</span></div>
                                <div><span>Year 2</span></div>
                                <div><span>Year 3</span></div>
                                <div v-if="duration>=4"><span>Year 4</span></div>
                                <div v-if="duration>=5"><span>Year 5</span></div>
                            </div>
                            <div class="section-data-row">
                                <div><span>Total Fees</span></div>
                                <div class="align-right"><span>${{ dollar(getTotalFees().total_fee_year_one) }}</span></div>
                                <div class="align-right"><span>${{ dollar(getTotalFees().total_fee_year_two) }}</span></div>
                                <div class="align-right"><span>${{ dollar(getTotalFees().total_fee_year_three) }}</span></div>
                                <div v-if="duration>=4" class="align-right"><span>${{ dollar(getTotalFees().total_fee_year_four) }}</span></div>
                                <div v-if="duration>=5" class="align-right"><span>${{ dollar(getTotalFees().total_fee_year_five) }}</span></div>
                            </div>
                        </div>
                        <div class="sections">
                            <v-toolbar color="primary custom-toolbar content-title" dark>Revenue Sharing Estimate</v-toolbar>
                            <div class="section-header">
                                <div><span>Year 0</span></div>
                                <div><span>Year 1</span></div>
                                <div><span>Year 2</span></div>
                                <div><span>Year 3</span></div>
                                <div v-if="duration>=4"><span>Year 4</span></div>
                                <div v-if="duration>=5"><span>Year 5</span></div>
                            </div>
                            <div class="section-data-row">
                                <div><span>Installation Credits</span></div>
                                <div class="align-right"><input :disabled="isPDFGenerated" v-model="json.installation_credit_year_one"></div>
                                <div class="align-right"><input :disabled="isPDFGenerated" v-model="json.installation_credit_year_two"></div>
                                <div class="align-right"><input :disabled="isPDFGenerated" v-model="json.installation_credit_year_three"></div>
                                <div v-if="duration>=4" class="align-right"><input :disabled="isPDFGenerated" v-model="json.installation_credit_year_four"></div>
                                <div v-if="duration>=5" class="align-right"><input :disabled="isPDFGenerated" v-model="json.installation_credit_year_five"></div>
                            </div>
                            <div class="section-data-row">
                                <div><span>Ongoing Credits</span></div>
                                <div class="align-right"><input :disabled="isPDFGenerated" v-model="json.ongoing_credit_year_one"></div>
                                <div class="align-right"><input :disabled="isPDFGenerated" v-model="json.ongoing_credit_year_two"></div>
                                <div class="align-right"><input :disabled="isPDFGenerated" v-model="json.ongoing_credit_year_three"></div>
                                <div v-if="duration>=4" class="align-right"><input :disabled="isPDFGenerated" v-model="json.ongoing_credit_year_four"></div>
                                <div v-if="duration>=5" class="align-right"><input :disabled="isPDFGenerated" v-model="json.ongoing_credit_year_five"></div>
                            </div>
                            <v-divider></v-divider>
                            <div class="section-data-row">
                                <div><span>Total Credits</span></div>
                                <div class="align-right"><span>${{ dollar(json.total_credits_year_one) }}</span></div>
                                <div class="align-right"><span>${{ dollar(json.total_credits_year_two) }}</span></div>
                                <div class="align-right"><span>${{ dollar(json.total_credits_year_three) }}</span></div>
                                <div v-if="duration>=4" class="align-right"><span>${{ dollar(json.total_credits_year_four) }}</span></div>
                                <div v-if="duration>=5" class="align-right"><span>${{ dollar(json.total_credits_year_five) }}</span></div>
                            </div>
                            <div class="section-data-row" v-if="applyRevShare">
                                <div><span>Revenue Share Carryover</span></div>
                                <div class="align-right"><span>${{ dollar(json.revenue_share_carryover_year_one) }}</span></div>
                                <div class="align-right"><span>${{ dollar(json.revenue_share_carryover_year_two) }}</span></div>
                                <div class="align-right"><span>${{ dollar(json.revenue_share_carryover_year_three) }}</span></div>
                                <div v-if="duration>=4" class="align-right"><span>${{ dollar(json.revenue_share_carryover_year_four) }}</span></div>
                                <div v-if="duration>=5" class="align-right"><span>${{ dollar(json.revenue_share_carryover_year_five) }}</span></div>
                            </div>
                            <div class="section-data-row">
                                <div><span>Billed Fee</span></div>
                                <div class="align-right"><span>${{ dollar(json.net_fee_year_one) }}</span></div>
                                <div class="align-right"><span>${{ dollar(json.net_fee_year_two) }}</span></div>
                                <div class="align-right"><span>${{ dollar(json.net_fee_year_three) }}</span></div>
                                <div v-if="duration>=4" class="align-right"><span>${{ dollar(json.net_fee_year_four) }}</span></div>
                                <div v-if="duration>=5" class="align-right"><span>${{ dollar(json.net_fee_year_five) }}</span></div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-switch
                        v-model="applyRevShare"
                        label="Apply Revenue Share"
                        class="ma-0"
                        hide-details
                        @click.native.stop
                        @change="compute_totals()"
                        :disabled="isPDFGenerated"
                        >
                        </v-switch>
                        <v-spacer></v-spacer>
                        <v-btn class="update-credit-btn" color="primary" dark @click="record_keeping_credit_dialog = false">
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {cleanNumber, totalPricingSectionTablePreset} from '@/store/global_helpers/utility.js';
    export default {
        name: 'record_keeping_credit_dialog',
        props: {
            viewModel: [Object],
        },
        mounted(){
            console.log('PropRecordKeepingCredit mounted');
            this.viewModel.pricing.applyRevShare = true
            this.json = this.viewModel.pricing;
            this.duration = this.planOpportunityViewmodel.plan_opportunity.duration;
        },
        data: function() {
            return {
                duration: 5,
                applyRevShare: true,
                styleElement: null,
                record_keeping_credit_dialog: false,
                window: {
                    width: 0,
                    height: 0
                },
                json: false,
            }
        },

        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },

        computed: {
      ...mapGetters({
          planOpportunityViewmodel: 'getplanOpportunityViewmodel',
          isPDFGenerated: 'getIsPDFGenerated',
          pricingTable: "getTablePresetItems",
          }),
            style() {
                if (this.record_keeping_credit_dialog) {
                    return `
                    .v-dialog {
                        margin: 3px !important;
                    }
                    `
                }
                return ''
            },
            mobile () {
                switch (this.$vuetify.breakpoint.name) {
                case 'xs': return true;
                case 'sm': return true;
                case 'md': return false;
                case 'lg': return false;
                case 'xl': return false;
                }
                return null
            },
        },

        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },

        methods: {
            dollar(val){
                return Number(parseInt(val)).toLocaleString("US", {currency: "USD"});
            },

            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
            },
            
            applyStyle(styleDef) {
                let styleElement = document.createElement('style')
                styleElement.type = 'text/css'
                document.head.appendChild(styleElement)
                styleElement.innerHTML = styleDef
                return styleElement
            },

            compute_totals() {
                console.log('compute_totals called')
                if (!this.json) return;
                console.log('computing totals');
                if (this.applyRevShare){
                    this.json.total_credits_year_one = parseInt(this.json.installation_credit_year_one || 0) + parseInt(this.json.ongoing_credit_year_one || 0);
                    this.json.total_credits_without_carryover_year_one = parseInt(this.json.installation_credit_year_one || 0) + parseInt(this.json.ongoing_credit_year_one)
                    
                    if (this.json.total_credits_year_one > this.getTotalFees().total_fee_year_one) {
                        this.json.revenue_share_carryover_year_one = this.json.total_credits_year_one - parseInt(this.getTotalFees().total_fee_year_one || 0);
                        this.json.net_fee_year_one = 0;
                    } else {
                        this.json.revenue_share_carryover_year_one = 0;
                        this.json.net_fee_year_one = parseInt(this.getTotalFees().total_fee_year_one || 0) - this.json.total_credits_year_one;
                    }

                    this.json.total_credits_year_two = parseInt(this.json.installation_credit_year_two || 0) 
                                                + parseInt(this.json.ongoing_credit_year_two || 0) 
                                                + parseInt(this.json.revenue_share_carryover_year_one || 0);
                    this.json.total_credits_without_carryover_year_two = parseInt(this.json.installation_credit_year_two || 0) + parseInt(this.json.ongoing_credit_year_two)

                    if (this.json.total_credits_year_two > this.getTotalFees().total_fee_year_two) {
                        this.json.revenue_share_carryover_year_two = this.json.total_credits_year_two - parseInt(this.getTotalFees().total_fee_year_two || 0);
                        this.json.net_fee_year_two = 0;
                    } else {
                        this.json.revenue_share_carryover_year_two = 0;
                        this.json.net_fee_year_two = parseInt(this.getTotalFees().total_fee_year_two || 0) - this.json.total_credits_year_two;
                    }

                    this.json.total_credits_year_three = parseInt(this.json.installation_credit_year_three || 0) 
                                                + parseInt(this.json.ongoing_credit_year_three || 0)
                                                + parseInt(this.json.revenue_share_carryover_year_two || 0);
                    this.json.total_credits_without_carryover_year_three = parseInt(this.json.installation_credit_year_three || 0) + parseInt(this.json.ongoing_credit_year_three)

                    if (this.json.total_credits_year_three > this.getTotalFees().total_fee_year_three) {
                        this.json.revenue_share_carryover_year_three = this.json.total_credits_year_three - parseInt(this.getTotalFees().total_fee_year_three || 0);
                        this.json.net_fee_year_three = 0;
                    } else {
                        this.json.revenue_share_carryover_year_three = 0;
                        this.json.net_fee_year_three = parseInt(this.getTotalFees().total_fee_year_three || 0) - this.json.total_credits_year_three;
                    }

                    this.json.total_credits_year_four = parseInt(this.json.installation_credit_year_four || 0) 
                                                + parseInt(this.json.ongoing_credit_year_four || 0)
                                                + parseInt(this.json.revenue_share_carryover_year_three || 0);
                    this.json.total_credits_without_carryover_year_four = parseInt(this.json.installation_credit_year_four || 0) + parseInt(this.json.ongoing_credit_year_four)

                    if (this.json.total_credits_year_four > this.getTotalFees().total_fee_year_four) {
                        this.json.revenue_share_carryover_year_four = this.json.total_credits_year_four - parseInt(this.getTotalFees().total_fee_year_four || 0);
                        this.json.net_fee_year_four = 0;
                    } else {
                        this.json.revenue_share_carryover_year_four = 0;
                        this.json.net_fee_year_four = parseInt(this.getTotalFees().total_fee_year_four || 0) - this.json.total_credits_year_four;
                    }

                    this.json.total_credits_year_five = parseInt(this.json.installation_credit_year_five || 0) 
                                                + parseInt(this.json.ongoing_credit_year_five || 0)
                                                + parseInt(this.json.revenue_share_carryover_year_four || 0);
                    this.json.total_credits_without_carryover_year_five = parseInt(this.json.installation_credit_year_five || 0) + parseInt(this.json.ongoing_credit_year_five)
                    
                    if (this.json.total_credits_year_five > this.getTotalFees().total_fee_year_five) {
                        this.json.revenue_share_carryover_year_five = this.json.total_credits_year_five - parseInt(this.getTotalFees().total_fee_year_five || 0);
                        this.json.net_fee_year_five = 0;
                    } else {
                        this.json.revenue_share_carryover_year_five = 0;
                        this.json.net_fee_year_five = parseInt(this.getTotalFees().total_fee_year_five || 0) - this.json.total_credits_year_five;
                    }                    
                } else {
                    this.json.total_credits_year_one = parseInt(this.json.installation_credit_year_one || 0) + parseInt(this.json.ongoing_credit_year_one || 0);
                    this.json.total_credits_year_two = parseInt(this.json.installation_credit_year_two || 0) + parseInt(this.json.ongoing_credit_year_two || 0);
                    this.json.total_credits_year_three = parseInt(this.json.installation_credit_year_three || 0) + parseInt(this.json.ongoing_credit_year_three || 0);
                    this.json.total_credits_year_four = parseInt(this.json.installation_credit_year_four || 0) + parseInt(this.json.ongoing_credit_year_four || 0);
                    this.json.total_credits_year_five = parseInt(this.json.installation_credit_year_five || 0) + parseInt(this.json.ongoing_credit_year_five || 0);
                    this.json.revenue_share_carryover_year_one = 0;
                    this.json.revenue_share_carryover_year_two = 0;
                    this.json.revenue_share_carryover_year_three = 0;
                    this.json.revenue_share_carryover_year_four = 0;
                    this.json.revenue_share_carryover_year_five = 0;
                    this.json.net_fee_year_one = this.getTotalFees().total_fee_year_one;
                    this.json.net_fee_year_two = this.getTotalFees().total_fee_year_two;
                    this.json.net_fee_year_three = this.getTotalFees().total_fee_year_three;
                    this.json.net_fee_year_four = this.getTotalFees().total_fee_year_four;
                    this.json.net_fee_year_five = this.getTotalFees().total_fee_year_five;
                }
            },
            
            getTotalPricingSectionTablePreset(section){
                return totalPricingSectionTablePreset(this.pricingTable, section)
            },

            total_annual_fees(){
                const total = this.getTotalPricingSectionTablePreset("Annual Fee")
                return {
                    total_annual_fee_year_one:   this.dollar(total),
                    total_annual_fee_year_two:   this.dollar(total),
                    total_annual_fee_year_three: this.dollar(total),
                    total_annual_fee_year_four:  this.dollar(total),
                    total_annual_fee_year_five:  this.dollar(total),
                }
            },

            total_setup_fees(){
                const total = this.getTotalPricingSectionTablePreset("Setup & Installation Fees")
                return{
                    total_setup_fee_year_one:   this.dollar(total),
                    total_setup_fee_year_two:   this.dollar(0),
                    total_setup_fee_year_three: this.dollar(0),
                    total_setup_fee_year_four:  this.dollar(0),
                    total_setup_fee_year_five:  this.dollar(0)
                }
            },

            total_fees() {
                const total = cleanNumber(this.total_annual_fees().total_annual_fee_year_one) + cleanNumber(this.total_setup_fees().total_setup_fee_year_one)
                return {
                    total_fee_year_one:   total,
                    total_fee_year_two:   cleanNumber(this.total_annual_fees().total_annual_fee_year_one),
                    total_fee_year_three: cleanNumber(this.total_annual_fees().total_annual_fee_year_one),
                    total_fee_year_four:  cleanNumber(this.total_annual_fees().total_annual_fee_year_one),
                    total_fee_year_five:  cleanNumber(this.total_annual_fees().total_annual_fee_year_one),
                }
            },

            isPricingTable(){
                let isPricingTable = false
                if(this.viewModel){
                    isPricingTable = this.viewModel.packet.is_html_template
                }
                return isPricingTable
            },
            getTotalFees(){
                if(this.viewModel && this.isPricingTable()){
                    return this.total_fees()
                }
                else return this.json
            },

        },

        
        watch: {
            style: function(style) {
                if (this.styleElement) {
                    this.styleElement.parentNode.removeChild(this.styleElement)
                }
                this.styleElement = this.applyStyle(style)
            },

            json: {
                deep:true,
                handler() {
                    this.compute_totals();
                }
            },
            applyRevShare:{
                deep:true,
                handler() {
                    console.log("this.applyRevShare")
                    this.viewModel.pricing.applyRevShare = this.applyRevShare
                    console.log(this.applyRevShare)
                    console.log(this.viewModel.pricing.applyRevShare)
                }
            }
        },

    }

</script>

<style scoped>
    button {
        border: solid 1px #999;
        border-radius: 5px;
        font-size: 13px;
        color: #444;
        text-transform: uppercase;
        margin: 0;
        margin-top: -6px;
        margin-right: 12px;
        padding: 0 8px;
    }

    input, .align-right {
        text-align: right !important;
    }

    .custom-toolbar,
    .custom-toolbar >>> .v-toolbar__content {
        height: 50px !important;
    }

    .custom-toolbar span {
        flex-grow: 1;
    }

    .custom-toolbar.content-title, 
    .custom-toolbar.content-title >>> .v-toolbar__content {
        height: 35px !important;
        line-height: 27px;
        display: block;
        text-align: center;
        margin-bottom: 15px;
    }

    .sections {
        margin-top: 15px;
    }

    .data-row-label {
        min-width: 200px;
    }

    .data-row-amount {
        min-height: 30px;
        text-align: left;
        overflow-x: scroll;
        overflow-y: hidden;
    }

    .data-row-amount-header,
    .section-header,
    .section-header-mobile,
    .section-data-row,
    .section-data-row-mobile,
    .data-row-amount-one,
    .data-row-amount-two,
    .data-row-amount-total,
    .data-row-amount-carryover {
        display: flex;
        width: 100%;
    }

    .sections:nth-of-type(2) .section-content-wrapper {
        margin-top: 50px;
    }

    .sections .section-header-mobile > div,
    .sections .section-data-row-mobile > div {
        padding: 10px;
        margin-left: 5px;
        margin-right: 5px;
        text-align: center;
        line-height: 1;
    }

    .sections:nth-of-type(1) .section-header-mobile > div,
    .sections:nth-of-type(1) .section-data-row-mobile > div {
        width: calc(25% - 5px);
    }

    .sections:nth-of-type(2) .section-header-mobile > div,
    .sections:nth-of-type(2) .section-data-row-mobile > div {
        width: calc(20% - 5px);
        position: relative;
        text-align: initial;
    }

    .sections:nth-of-type(2) .section-header-mobile > div span {
        position: absolute;
        bottom: 0;
        text-align: center;
    }

    .sections:nth-of-type(2) .section-data-row-mobile > div:nth-of-type(n+2):not(:nth-of-type(n+4)) {
        word-wrap: break-word;
        word-break: break-all;
        background-color: lightblue;
    }
    
    .sections:nth-of-type(2) .section-data-row-mobile > div:nth-of-type(4) input {
        font-weight: 600;
        color: #13cc44;
        text-align: center;
        background-color: transparent;
        pointer-events: none;
    }

    .sections:nth-of-type(2) .section-data-row-mobile > div:nth-of-type(5) input {
        text-align: center;
        pointer-events: none;
    }

    @media only screen and (min-width: 397px) {

        .sections:nth-of-type(2) .section-data-row-mobile > div:nth-of-type(n+2) {
            max-height: 36px;
        }
    }

    .sections:nth-of-type(2) .section-data-row-mobile > div input,
    .sections:nth-of-type(2) .section-data-row-mobile > div input {
        width: 100%;
        resize: none;
        outline: none;
        overflow: hidden;
    }
    
    .section-header-mobile > div {
        padding-bottom: 2px !important;
    }

    .sections:nth-of-type(2) .section-data-row-mobile {
        padding-top: 20px;
    }

    .section-header-mobile > div:nth-of-type(n+2) {
        border-bottom: 1px solid grey;
    }

    .sections:nth-of-type(1) .section-data-row-mobile > div:nth-of-type(4) {
        font-weight: 600;
    }



    /* NON MOBILE CSS */

    .sections .section-header > div:nth-of-type(1),
    .sections .section-data-row > div:nth-of-type(1) {
        width: 200px;
        font-weight: 600;
        margin: 10px 10px 10px 10px;
        padding: 5px;
        max-height: 30px;
    }

    .sections .section-header > div:nth-of-type(1) {
        color: transparent;
    }

    .sections .section-header > div:nth-of-type(n+2),
    .sections .section-data-row > div:nth-of-type(n+2) {
        width: calc(20% - 5px);
        text-align: center;
        margin: 10px 10px 10px 10px;
        padding: 5px;
        background-color: lightblue;
    }

    .sections .section-header > div,
    .sections:nth-of-type(1) .section-data-row > div:nth-of-type(n+2),
    .sections .section-data-row:nth-of-type(n+4) > div {
        background-color: transparent !important;
    }

    .sections:nth-of-type(2) .section-data-row:nth-of-type(4) > div:nth-of-type(n+2) {
        font-weight: 600;
        color: #13cc44;
    }

    .sections .section-header > div:nth-of-type(n+2) {
        border-bottom: 1px solid grey;
    }

    .sections .section-data-row > div input {
        width: 100%;
        outline: none;
    }

    .sections:nth-of-type(1) .section-data-row:nth-of-type(3) > div input {
        width: 100%;
        outline: none;
    }
    
    .update-credit-btn >>> .v-btn__content {
        text-transform: capitalize;
    }


    /**************** MEDIA QUERY ***************/

    @media only screen and (min-width: 769px) {
        .sections .section-header > div:nth-of-type(1),
        .sections .section-data-row > div:nth-of-type(1) {
            width: 350px;
        }
    }


</style>